import { Box } from '@astro-ui/components'
import styled from 'styled-components'
import { useAppSelector, shallowEqual } from 'store'
import QRCode from 'react-qr-code'

const splitSlocName = (name: string) => {
  const parts = (name ?? '').split('-')

  if (parts.length < 3) {
    return {
      prefix: name,
      tail: '',
    }
  }

  const tail = parts.slice(-2).join('-')
  const prefix = parts.slice(0, -2).join('-')

  return { prefix, tail }
}

const truncateText = (text: string, maxLength: number) => {
  if (!text) return ''
  if (text.length <= maxLength) return text
  return `${text.substring(0, maxLength)}...`
}

const TemplatePrintBarcodeSloc = () => {
  const barcodeSlocToPrint = useAppSelector((s) => s.rack.barcodeSlocToPrint, shallowEqual)

  return (
    <div>
      {barcodeSlocToPrint.map((item) => {
        const { prefix, tail } = splitSlocName(`${item.rack_name}`)

        return (
          <StyledContainerBarcode key={item.id}>
            <RowNoWrap>
              <StyledContainerQrCode>
                <QRCode value={item.rack_name} style={{ width: '100%', height: '100%' }} />
              </StyledContainerQrCode>

              <StyledContainerLabelContent>
                <StyledLabelTitle>
                  <span>{prefix}</span>
                  {tail && <StyledDash>-</StyledDash>}
                  {tail && <StyledTitleBadge>{tail}</StyledTitleBadge>}
                </StyledLabelTitle>

                <StyledLabelDetails>
                  <div
                    style={{
                      visibility: item.mix_product ? 'visible' : 'hidden',
                    }}
                  >
                    Mix Product
                  </div>
                  <Box marginTop="1mm">
                    {item?.area_name && truncateText(`${item.area_name}`, 32)}
                  </Box>
                  <Box marginTop="1mm">SLOC ID : {item.id}</Box>
                  {item.is_halal === false && <Box marginTop="1mm">Tag: Non Halal</Box>}
                </StyledLabelDetails>
              </StyledContainerLabelContent>
            </RowNoWrap>
          </StyledContainerBarcode>
        )
      })}
    </div>
  )
}

/* ====== styles ====== */

const StyledContainerBarcode = styled.div`
  display: flex;
  flex-direction: column;
  width: 80mm; /* 8 cm */
  height: 30mm; /* 3 cm */
  padding: 2mm 3mm;
  box-sizing: border-box;
  justify-content: center;

  @media print {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
    page-break-inside: avoid;
    break-inside: avoid;

    @page {
      size: 80mm 30mm;
      margin: 0mm;
    }
  }
`

const StyledLabelTitle = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  font-size: 4.6mm;
  font-weight: 700;
  white-space: nowrap;
  margin-bottom: 1.2mm;
  line-height: 1.25;
`

const StyledDash = styled.span`
  font-weight: 700;
`

const StyledTitleBadge = styled.span`
  background: #000;
  color: #fff;
  font-weight: 800;
  font-size: 6.8mm;
  padding: 0.5mm 0mm;
`

const RowNoWrap = styled(Box).attrs({ display: 'flex', alignItems: 'flex-start' })`
  gap: 2mm;
  flex-wrap: nowrap;
`

const StyledContainerQrCode = styled.div`
  flex: 0 0 22mm;
  width: 22mm;
  height: 22mm;
  display: flex;
  align-items: center;
  justify-content: center;
`

const StyledContainerLabelContent = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  height: 22mm;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const StyledLabelDetails = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 2mm;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
`

export default TemplatePrintBarcodeSloc
